import React from 'react';
import * as PropTypes from 'prop-types';
import { Alert, Row } from 'antd';
import './ViaFields.css';

// Displays a warning box with validation messages if passed an error body from the server.
// Will not show an error if it isn't a 400 error as these are not usually errors we want to show to the user.
// * Changed to not show heading/message to save space - this message is shown in a toast message
export default function ViaValidationAlert({
  validationError,
  className,
  type,
  showIcon,
  ...props
}) {
  if (!validationError || validationError.code !== 400) {
    return (<></>);
  }

  return (
    <Alert
      className={className}
      description={validationError.errors.map(msg => <Row key={msg}>{msg}</Row>)}
      type={type}
      showIcon={showIcon}
      {...props}
    />
  );
}

ViaValidationAlert.propTypes = {
  // TLDR: location.state.sourceLocation.pathname is a required string.
  validationError:
    PropTypes.shape({
      errorMessage: PropTypes.string.isRequired,
      errors: PropTypes.array.isRequired,
      code: PropTypes.number.isRequired,
    }),
  className: PropTypes.string,
  type: PropTypes.string,
  showIcon: PropTypes.bool,
};

ViaValidationAlert.defaultProps = {
  validationError: null,
  className: null,
  showIcon: true,
  type: 'warning',
};
